<template>
    <common-el-form :model="formModel" :submitData="submitData" @success="onSuccess"
                    @cancel="onCancel" submit-btn-text="保存" failTitle="提交失败" loadingText="提交中..."
                    :submitService="submitService" :showButton="false" :rules="formRules" labelWidth="110px">
        <!--<p class="commonTitle">返利钱包</p>-->
        <el-form-item label="返利钱包" prop="enableRebate">
            <el-switch
                v-model="formModel.enableRebate"
                active-value="1"
                inactive-value="0">
            </el-switch>
        </el-form-item>
        <el-form-item label="反利方式" prop="enableRebateGive">
            <el-radio-group v-model="formModel.enableRebateGive" :disabled="formModel.enableRebate != 1">
                <el-radio label="0">购买</el-radio>
                <el-radio label="1">赠送</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="赠送金额（元）" prop="rebateMinRechargeMoney" v-if="formModel.enableRebateGive == 1">
            <el-input-number v-model="formModel.rebateMinRechargeMoney" controls-position="right" :precision="2"
                             :step="0.1" :controls="false" :min="0" :max="999999999" :disabled="!isBuy"></el-input-number>
        </el-form-item>
        <el-form-item label="上级补贴" v-else>
            <div class="flex-col vertical-start up-level-box">
                <el-button type="primary" size="small" @click="addLevelItem" :disabled="!isBuy" style="margin-bottom: 20px">
                    添加
                </el-button>

                <div class="rebateRechargeTransformation">
                    <div class="flex-row vertical-center up-people-list"
                         v-for="(item, index) in formModel.rebateRechargeTransformation" :key="index"
                         style="margin-bottom: 20px; justify-content: flex-start;">
                        <p class="unit commonMargin">充值</p>
                        <el-form-item :prop="'rebateRechargeTransformation.' + index + '.awardsPercent'"
                                      :rules="awardsPercentRules">
                            <el-input-number placeholder="请输入充值金额" :controls="false"
                                             v-model="item.awardsPercent" controls-position="right"
                                             :min="0" :max="999999999" :precision="2" class="commonMargin"
                                             :step="0.1" :disabled="!isBuy"></el-input-number>
                            <p class="unit commonMargin">元</p>
                        </el-form-item>
                        <p class="unit commonMargin">返赠</p>
                        <el-form-item :prop="'rebateRechargeTransformation.' + index + '.awardsPercent2'">
                            <el-input-number placeholder="请输入返赠金额" :controls="false"
                                             v-model="item.awardsPercent2" controls-position="right"
                                             :min="0" :max="999999999" :precision="2" class="commonMargin"
                                             :step="0.1" :disabled="!isBuy"></el-input-number>
                            <p class="unit commonMargin">元</p>
                        </el-form-item>
                        <el-button @click.prevent="removeLevelItem(item)" v-if="index > 0" :disabled="!isBuy">
                            删除
                        </el-button>
                    </div>
                </div>
            </div>
        </el-form-item>

        <el-form-item label="抵扣分润比率" prop="rebateTransformation">
            <el-input-number v-model="formModel.rebateTransformation" controls-position="right" :precision="2"
                             :step="0.1" :controls="false" :disabled="!isBuy"
                             :min="0" :max="1" style="width: 100%"></el-input-number>
            <p class="notice-msg">（抵扣金额 = 交易手续费 * 抵扣比例）</p>
        </el-form-item>
        <el-form-item prop="rebateInfo" label="备注">
            <el-input type="textarea" maxlength="100" :disabled="!isBuy" show-word-limit resize="none" rows="4" v-model="formModel.rebateInfo" style="width: 250px;"></el-input>
        </el-form-item>

        <el-form-item prop="rebateEnablePayment">
            <el-checkbox v-model="formModel.rebateEnablePayment" :disabled="!isBuy" true-label="1" false-label="0">是否包含代付费</el-checkbox>
        </el-form-item>
    </common-el-form>
</template>

<script>
    import CommonElForm from 'components/common/CommonElForm'
    import Regs from "common/conf/Regs";
    import OrganService from 'service/OrganService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, validatorsMixin} from "mixin";
    import StorageService from 'store/interfaces';
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "AddOrganManage",
        props: {
            formModel: {
                type: Object,
                default: () => {
                }
            },
            organInfo: {
                type: Object,
                default: () => {
                }
            }
        },
        data() {
            return {
                submitService: OrganService.update,
                formRules: {
                    rebateTransformation: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请输入抵扣分润比率'))
                            } else {
                                callback()
                            }
                        },
                    }],
                    rebateInfo:[{
                        required: true,
                        message: '请输入备注'
                    }]
                },
                awardsPercentRules: [{
                    required: false,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            return callback(new Error('请输入充值金额'))
                        }
                        callback()
                    },
                    trigger: ['blur', 'change']
                }],
            }
        },
        watch: {
            formModel(val, oldVal) {
                if (!val.rebateRechargeTransformation) {
                    this.formModel.rebateRechargeTransformation = [{
                        awardsPercent: '',
                        awardsPercent2: '',
                    }];
                    return
                }
                if (typeof val.rebateRechargeTransformation == 'string') {
                    this.formModel.rebateRechargeTransformation =  val.rebateRechargeTransformation.split(';');
                    let arr = [];
                    this.formModel.rebateRechargeTransformation.forEach(item => {
                        arr.push({
                            awardsPercent: item.split(',')[0],
                            awardsPercent2: item.split(',')[1],
                        })
                    });
                    this.formModel.rebateRechargeTransformation = arr;
                }

            }
        },
        mixins: [loadMixin, validatorsMixin],
        components: {
            CommonElForm
        },
        computed: {
            isBuy() {
              return this.formModel.enableRebate == 1 && this.formModel.enableRebateGive == 0
            },
            submitData() {
                let rebateRechargeTransformation = '';
                if (this.formModel.rebateRechargeTransformation) {
                    this.formModel.rebateRechargeTransformation.forEach(item => {
                        rebateRechargeTransformation += item.awardsPercent + ',' + item.awardsPercent2 + ';'
                    });
                }
                this.params = {
                    rebateRechargeTransformation: rebateRechargeTransformation.substr(0, rebateRechargeTransformation.length - 1),
                    enableRebate: this.formModel.enableRebate,
                    enableRebateGive: this.formModel.enableRebateGive,
                    rebateTransformation: this.formModel.rebateTransformation,
                    rebateEnablePayment: this.formModel.rebateEnablePayment,
                    rebateInfo: this.formModel.rebateInfo,
                    id: this.organInfo.id,
                    userId: this.userId,
                };

                return this.params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods: {
            onSuccess(res) {
                this.$emit('onSuccess', res)
            },
            onCancel() {
                this.$emit('onCancel')
            },
            addLevelItem() {
                this.formModel.rebateRechargeTransformation.push({
                    awardsPercent: '',
                    awardsPercent2: '',
                });
            },
            removeLevelItem(item) {
                this.showConfirm('确定要删除此层级吗？').then(() => {
                    let index = this.formModel.rebateRechargeTransformation.indexOf(item);
                    if (index !== -1) {
                        this.formModel.rebateRechargeTransformation.splice(index, 1)
                    }
                }).catch(() => {
                });
            },
            ...mapActions({
                isReloadPage: StorageService.Reload.page,
            })
        }
    }
</script>

<style scoped>
    .el-form-item {
        display: flex;
        margin-right: 20px;
    }

    .box-card {
        margin-bottom: 30px;
    }

    .notice-msg {
        line-height: 1.8;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/OrganManage/RebateWallet.vue